import { BaseModel } from './BaseModel';
import Section from './Section';
import MeetingAccount from './MeetingAccount';
import MeetingRecord from './MeetingRecord';
// import Post from "./Post";

export class Meeting extends BaseModel {
  static get entity() {
    return 'meetings';
  }

  static get fk() {
    return 'meeting_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      join_url: this.string(''),
      meeting_id: this.attr(null),
      meeting_account: this.belongsTo(MeetingAccount, 'meeting_account_id'),
      section_id: this.attr(null),
      section: this.belongsTo(Section, 'section_id'),
      meeting_record_ids: this.attr([]),
      meeting_records: this.hasManyBy(MeetingRecord, 'meeting_record_ids'),
      post_id: this.attr(null),
      start_time: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      getMeetingBySection(sectionId) {
        return this.get(`/sections/${sectionId}/meetings`);
      }
    }
  };
}

export default Meeting;
